import { render, staticRenderFns } from "./AsignacionTurnoSection.vue?vue&type=template&id=a2789e34&scoped=true"
import script from "./AsignacionTurnoSection.vue?vue&type=script&lang=js"
export * from "./AsignacionTurnoSection.vue?vue&type=script&lang=js"
import style0 from "./AsignacionTurnoSection.vue?vue&type=style&index=0&id=a2789e34&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2789e34",
  null
  
)

export default component.exports